var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",staticStyle:{"width":"14rem"}},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.link}}),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.msg)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }